import React, { useContext } from 'react'
import { RolePermissions, PermissionContext } from "appContext";
import SearchSchools from './SearchSchools';
import { pages } from '../../common/constant';
import { PermisionDenied } from '../../common/commonComponents';

const SchoolMasterSetup = (props) => {
      const userPermissions = RolePermissions(
        useContext(PermissionContext),
        pages["schoolMaster"]["id"]
      );
    //   const userPermissions = RolePermissions(useContext(PermissionContext),pages["chargeModiConfig"]["id"]);
    const getAll=(props.routeKey=='/admin/schoolMaster/getAll')
    return userPermissions.length ? (
        <SearchSchools getAll={getAll}/>
      ) : (
        <PermisionDenied />
      );
}

export default SchoolMasterSetup;